import React from 'react'

import { Typography } from '@s4l/ds'
import type { ListOfBed } from '@s4l/stayforlong/booking/ListOfBed'
import { useS4LContext } from '@s4l/react-context'
import type { UtilityClassNames } from '@s4l/utility-css'

import styles from './styles.module.css'
import { IconBedFilled } from '@s4l/icons/IconBedFilled'

interface IBedInfoProps {
  /**
   * List of beds to show
   */
  beds: ListOfBed
  /**
   * Hide the title
   */
  hideTitle?: boolean
  /**
   * Hide the icon
   */
  hideIcon?: boolean
}

function BedInfo(props: Readonly<IBedInfoProps>) {
  const { beds, hideTitle = false, hideIcon = false } = props
  const { i18n } = useS4LContext()

  if (beds.isEmpty()) return null

  const title = i18n.formatMessage({ id: 'room.beds' })

  return (
    <div className={styles.bedType}>
      {!hideTitle && (
        <Typography
          variant="caption"
          size="l"
          as="span"
          className={styles.title as UtilityClassNames}
        >
          {title}
        </Typography>
      )}
      <div className={styles.bedWrapper}>
        {!hideIcon && <IconBedFilled size={16} />}
        {beds.map((bed, index) => {
          return (
            <div key={bed.type().value()} className={styles.bedContent}>
              <Typography
                variant="caption"
                size="l"
                bold
              >{`${bed.quantity()} ${bed.description()}`}</Typography>
              {index + 1 < beds.length ? (
                <span className={styles.separator} data-testid="separator">
                  ·
                </span>
              ) : null}
            </div>
          )
        })}
      </div>
    </div>
  )
}

BedInfo.displayName = 'BedInfo'

export default BedInfo
